import React from 'react';
import PropTypes from 'prop-types';

function DiveMessageBanner({
  additionalClasses = '',
  children: messageContent, // children is a special prop, so we have to rename like so
  isClosable = true,
  messageType = 'info',
  onClose = () => {},
}) {
  return (
    <div className={`message message--${messageType} ${additionalClasses}`}>
      {messageContent}
      {isClosable && (
        <button style={{ display: 'block' }} type="button" onClick={onClose}>
          <img
            className="message__close"
            src="/static/img/components/messages/close.svg"
            alt="close"
          />
        </button>
      )}
    </div>
  );
}

DiveMessageBanner.propTypes = {
  additionalClasses: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.string,
    ])),
    PropTypes.element,
    PropTypes.string,
  ]).isRequired,
  isClosable: PropTypes.bool,
  messageType: PropTypes.oneOf(['success', 'error', 'warning', 'info', 'debug']),
  onClose: PropTypes.func,
};

export default DiveMessageBanner;
